import { useEffect } from "react";

const useCaptcha = ({
    setIsVerified,
    captchaName,
}: {
    setIsVerified: (value: boolean) => void;
    captchaName: string;
}) => {
    const addCaptchaScripts = () => {
        if (document.querySelector("#mtcaptcha-script") && document.querySelector("#mtcaptcha-script2")) {
            removeCaptchaScripts();
        };
        
        // @ts-expect-error
        window.mtcaptchaConfig = {
            sitekey: "MTPublic-ZhYaX15p1",
            'verified-callback': "onCaptchaSuccess",
            renderQueue: ['mtcaptcha', 'mtcaptcha-intern'],
            autoFormValidate: false,
            render: 'explicit',
            lang: 'pt',
        };

        const script1 = document.createElement('script');
        script1.id = 'mtcaptcha-script';
        script1.async = true;
        script1.src = 'https://service.mtcaptcha.com/mtcv1/client/mtcaptcha.min.js';
        document.body.appendChild(script1);

        const script2 = document.createElement('script');
        script2.id = 'mtcaptcha-script2';
        script2.async = true;
        script2.src = 'https://service2.mtcaptcha.com/mtcv1/client/mtcaptcha2.min.js';
        document.body.appendChild(script2);

    };

    const removeCaptchaScripts = () => {
        const script1 = document.querySelector("#mtcaptcha-script");
        if (script1) {
            document.body.removeChild(script1);
        }

        const script2 = document.querySelector("#mtcaptcha-script2");
        if (script2) {
            document.body.removeChild(script2);
        }

        // @ts-expect-error
        window.mtcaptcha = undefined;
    };

    useEffect(() => {
        addCaptchaScripts();
        // @ts-expect-error
        window.onCaptchaSuccess = function () {
            // @ts-expect-error
            if (window?.mtcaptcha?.getStatus?.(captchaName)?.isVerified) {
                setIsVerified(true);
            }
        };
    }, []);
};

export default useCaptcha;